<template>
    <section class="home-sec7">
        <img v-if="width > 1024" src="../assets/images/section-bg-3.png" alt="" class="home-sec7-bg">
        <div class="sec-container">
            <img src="../assets/images/motion-3.gif" alt="">
            <div class="text-box">
                <p>برای نمایش برندتان در یکی از پربازدیدترین سایت های کشور همین حالا شروع کنید</p>
                <button class="btn btn--consult" @click.stop="openModal">مشاوره رایگان</button>
            </div>
            <ModalBox :isModalOpen="showModal" @close="closeModal"></ModalBox>
        </div>
    </section>
</template>
<script>
import ModalBox from './ModalBox.vue';
import { useModal } from '@/useModal';
import { inject } from 'vue';
export default {
    name: "HomeSection7",
    components: {
        ModalBox,
    },
    setup() {
        const width = inject('viewportWidth');
        const { showModal, openModal, closeModal } = useModal();

        return {
            width,
            showModal,
            openModal,
            closeModal,
        };
    },
}

</script>
<style scoped>
.home-sec7 {
    position: relative;
    align-items: center;
    max-height: 416px;
}

.home-sec7,
.home-sec7-bg,
.text-box {
    width: 100%;
}

.home-sec7,
.sec-container,
.text-box {
    display: grid;
}

.home-sec7-bg {
    margin-block: 79px 25px;
    max-height: 312px;
}

.home-sec7-bg,
.sec-container {
    grid-area: 1 / 1;
}

.sec-container {
    padding-inline: 23.959%;
    justify-items: center;
    gap: 25px;
}

.sec-container img {
    position: absolute;
    top: 0;
    width: 174px;
    aspect-ratio: 1 / 1;
    z-index: 1;
}

.text-box {
    background-color: rgba(255, 255, 255, 0.5);
    box-shadow: 0 2px 10px var(--shadow-light);
    backdrop-filter: blur(20px);
    border-radius: 20px;
    margin-top: 54px;
    padding: 145px 15.7% 72px;
    gap: 34px;
}

.text-box p {
    line-height: 28px;
    text-align: center;
}

.text-box button {
    justify-self: center;
}

@media screen and (min-width: 1921px) {
    .sec-container {
        width: 1000px;
        margin-inline: auto;
        padding-inline: 0;
    }
}

@media screen and (max-width: 1440px) {
    .text-box {
        padding-block: 135px 50px;
        gap: 30px;
    }
}

@media screen and (max-width: 1024px) {
    .home-sec7 {
        margin-inline: 5.556%;
        width: calc(100% - 11.112%);
    }

    .sec-container {
        padding-inline: 0;
    }

    .text-box {
        box-shadow: 0 0 2px var(--shadow-light);
        padding-block: 130px 32px;
    }

    .text-box p {
        line-height: 26px;
    }
}

@media screen and (max-width: 768px) {
    .sec-container img {
        width: 160px;
    }
}

@media screen and (max-width: 375px) {
    .text-box p {
        font-size: 16px;
    }
}

@media screen and (max-width: 360px) {
    .sec-container {
        gap: 21px;
    }

    .sec-container img {
        width: 100px;
    }

    .text-box {
        margin-top: 50px;
        padding: 61px 8.7% 22px;
        gap: 13px;
    }
}
</style>